import { $api } from "../generated/client";

export default function useAllViewerShops() {
  return $api.useQuery("get", "/shops");
}
